module.exports = __webpack_public_path__ + "img/cardFuncionarioImg.1507d06f.jpg";